import * as Linking from "expo-linking";

export default {
  prefixes: [Linking.makeUrl("/")],
  config: {
    screens: {
      Root: {
        screens: {
          Home: "",
          StateOfTheLeague: "state-of-the-league",
          GiulianoCast: "giuliano-cast",
        },
      },
      NotFound: "*",
    },
  },
};
